/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import Scroll from "./locomotiveScroll"
import Header from "../components/header"
import Preloader from "../components/preloader"
import Menu from "../components/menu"
import BottomMenu from "../components/bottomMenu"
import Cursor from "../components/cursor"
import CursorImages from "../components/imageCursor"
import "../scss/site.scss"  

const Layout = ({ children, classes, about, approach, films, folio, store, contact, background, location, title }) => {
  if(location==='home') {
    var cursor = <CursorImages about={about} approach={approach} films={films} folio={folio} store={store} contact={contact}  />;
  }
  return (
    <main className={classes} style={{ background: background }} data-bg="dusk" data-page={location}> 
    {cursor}
    <Scroll callbacks={location} />
    <Preloader location={location}  />
    <Cursor />
    <Menu background={background} /> 
    <BottomMenu /> 
    
    <Header pageTitle={title} />
    <div className="data-scroll-container">
    	{children}
    </div>
    </main>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
